// extracted by mini-css-extract-plugin
export default {"container":"D2-z"};